import type { EnterpriseWorkspace } from 'v5/api/enterprise/enterprise.api';

/** Whose records a report holds: one workspace's, or the whole organisation's (no workspace filter). */
export type ReportScope =
  | { type: 'workspace'; workspace: EnterpriseWorkspace }
  | { type: 'organization' };

/** How the whole organisation is shown beside its workspaces when a report is downloaded. */
export interface ReportOrganization {
  name: string;
  iconUrl: string;
}

export function reportScopeWorkspaceId(scope: ReportScope): number | null {
  switch (scope.type) {
    case 'workspace':
      return scope.workspace.id;
    case 'organization':
      return null;
  }
}
